import React from 'react';

interface LoaderProps {
    text?: string;
    fullScreen?: boolean;
}

const Loader = ({ text, fullScreen = false }: LoaderProps) => {
    const containerStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        width: '100%',
        minHeight: fullScreen ? 'calc(100vh - 160px)' : '300px', // Center between header/footer (approx 160px combined)
        height: fullScreen ? '100%' : 'auto',
        flex: 1
    };

    const spinnerStyle: React.CSSProperties = {
        width: '50px',
        height: '50px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #000000',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
    };

    return (
        <div style={containerStyle}>
            <div style={spinnerStyle}></div>
            {text && <p style={{ marginTop: '20px', color: '#666' }}>{text}</p>}
            <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
};

export default Loader;
